import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Layout from '../layout/Layout'
import InvoiceSvg from '../other/svg/InvoiceSvg'
import ImportDocumentForm from '../molecules/ImportDocumentForm'
import { formatClientDetailsName } from 'src/helpers/formatClientDetailsName'
import { CREATE_IMPORT_DOCUMENT, RESET_IMPORT_DOCUMENT_PDF } from 'src/redux/importDocumentReducer'
import { FETCH_CLIENT } from 'src/redux/clientReducer'
import { RootReducer } from 'src/redux/rootReducer'
import { parseOptionalNumericId, useDocumentCreateParams } from 'src/helpers/addVehicleDocument'

const ImportDocumentCreate = (): JSX.Element => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { clientId, vehicleId, returnPath } = useDocumentCreateParams()
  const loading = useSelector((state: RootReducer) => state.importDocumentReducer.loading)
  const motorbike = useSelector((state: RootReducer) => {
    return state.motorbikesReducer.motorbikes.find((item) => item.id === vehicleId) ?? null
  })
  const client = useSelector((state: RootReducer) => {
    if (typeof clientId === 'string') {
      return state.clientReducer.client[clientId] ?? null
    }
    return null
  })
  const importDocumentPdf = useSelector((state: RootReducer) => state.importDocumentReducer.import_document_pdf)
  let motorbikeNumericId = 0
  if (motorbike !== null) {
    motorbikeNumericId = parseInt(motorbike.id, 10)
  } else if (typeof vehicleId === 'string') {
    motorbikeNumericId = parseInt(vehicleId, 10)
  }

  useEffect(() => {
    if (typeof clientId === 'string') {
      dispatch(FETCH_CLIENT(clientId))
    }
  }, [dispatch, clientId])

  useEffect(() => {
    return () => {
      dispatch(RESET_IMPORT_DOCUMENT_PDF())
    }
  }, [dispatch])

  useEffect(() => {
    if (importDocumentPdf !== null) {
      window.open(importDocumentPdf, '_blank')
      navigate(returnPath)
    }
  }, [importDocumentPdf, navigate, returnPath])

  const handleSubmit = (values: any): void => {
    const formClientId = parseOptionalNumericId(values.client_id)
    const resolvedClientId = formClientId === 0 ? parseOptionalNumericId(clientId) : formClientId
    if (resolvedClientId === 0) {
      return
    }
    dispatch(
      CREATE_IMPORT_DOCUMENT({
        ...values,
        client_id: resolvedClientId
      })
    )
  }

  const handleCancel = (): void => {
    navigate(returnPath)
  }

  return (
    <Layout
      name="import-document-create"
      iconComponent={<InvoiceSvg className="w-8 h-8 text-white" />}
      withFiler={false}
      withoutToolbar={false}>
      <div className="h-[calc(100vh-200px)] overflow-y-auto hide-scrollbar pb-10">
        <ImportDocumentForm
          key={`${clientId ?? ''}-${client === null ? 'pending' : String(client.id)}-${vehicleId ?? ''}`}
          initialValues={{
            client_id: typeof clientId === 'string' ? parseInt(clientId, 10) : 0,
            ...(client === null ? {} : { client_name: formatClientDetailsName(client) }),
            motorbike_id: Number.isNaN(motorbikeNumericId) ? 0 : motorbikeNumericId,
            motorbike_name: motorbike?.model,
            import_date: '',
            with_plates: false
          }}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          title="Create Import Document"
          submitButtonText="Create Import Document"
          loading={loading}
        />
      </div>
    </Layout>
  )
}

export default ImportDocumentCreate
